module.exports = __webpack_public_path__ + "media/images/4_help-ef8be3539999deff341c36e0b3ba135e.jpg";